export default __webpack_public_path__ + "static/6-dd41c71246e4b1c6edfc74374589332a.png";